module.exports = __webpack_public_path__ + "media/images/taxumo-77ad5a68d0153d72dfc5dd2e6a15f989.png";